export enum ControlWidth {
  None = 0,
  Small = 25,
  Medium = 50,
  Big = 75,
  Full = 100
}
